import { createStyles, makeStyles } from '@mui/styles';

const useNavigationButtonStyles = makeStyles(() =>
    createStyles({
        link: {
            textDecoration: 'none',
        },
    }),
);

export default useNavigationButtonStyles;
